import Vue from "vue";
import Router from "vue-router";
// import Home from '@/components/Home'
//初始化api
import DIC_API from "@/api/api_dictionary";
import api_dept from "@/api/api_dept.js";
import api_user from "@/api/api_user.js";
import $const from "@/common/constant";

// 懒加载方式，当路由被访问的时候才加载对应组件
const Login = resolve => require(["@/components/Login"], resolve);
import Home from "@/layout/index.vue";

// start
//注册页面
// const Login = resolve => require(['@/components/Login'], resolve)
const JgLogin = resolve => require(['@/components/JgLogin'], resolve)
const wechatMall = resolve => require(['@/components/hmall'], resolve)
const wechatMallType = resolve => require(['@/components/hmallType'], resolve)

const Register = resolve => require(['@/components/register/index'], resolve)
const Success = resolve => require(['@/components/register/success'], resolve)

const invite = resolve => require(['@/pages/EntManagenment/invite/popup/start.vue'], resolve)


const Recommend = resolve => require(['@/components/recommend/index.vue'], resolve)

const Customer = resolve => require(['@/components/customer/index.vue'], resolve)

const Detail = resolve => require(['@/pages/webMall/index/detail.vue'], resolve)
// end
// 异常页面
const NotFount = resolve => require(["@/pages/exception/404"], resolve);
import questionBankManagenment from "@/pages/examination/questionBankManagenment";
import mallQuestionBankManagenment from "@/pages/mall/examination/questionBankManagenment";
import paperManagement from "@/pages/examination/paperManagement";
import mallPaperManagement from "@/pages/mall/examination/paperManagement";
import examManagement from "@/pages/examination/examManagement";
import examStatistics from "@/pages/examination/examStatistics";
import issueExam from "@/pages/examination/issueExam";
import directory from "@/pages/trainingManagement/directory";
import mallDirectory from "@/pages/mall/trainingManagement/directory";
import examStatisticsDetail from "@/pages/examination/examStatisticsDetail";
import addPaper from "@/pages/examination/addPaper";
import mallAddPaper from "@/pages/mall/examination/addPaper";
import addQuestion from "@/pages/examination/addQuestion";
import mallAddQuestion from "@/pages/mall/examination/addQuestion";
// 课程管理
import courseManagement from "@/pages/trainingManagement/course/courseManagement";
import mallCourseManagement from "@/pages/mall/course/courseManagement";

import addCourse from "@/pages/trainingManagement/course/addCourse";
import mallAddCourse from "@/pages/mall/course/addCourse";
// 师资管理
import teacherManagement from "@/pages/trainingManagement/teacherManagement";
import addTeacher from "@/pages/trainingManagement/addTeacher";

import trainingResource from "@/pages/trainingManagement/trainingResource";
import mallTrainingResource from "@/pages/mall/trainingManagement/trainingResource";
import addProgram from "@/pages/trainingManagement/addProgram";
import latojaManagement from "@/pages/trainingManagement/latojaManagement";

// training task
import trainingTask from "@/pages/trainingManagement/task/trainingTask";
import publishTask from "@/pages/trainingManagement/task/publishTask";
import selectCourse from "@/pages/trainingManagement/task/selectCourse";

import trainingResourceDetail from "@/pages/trainingManagement/trainingResourceDetail";
import mallTrainingResourceDetail from "@/pages/mall/trainingManagement/trainingResourceDetail";
import trainingDetail from "@/pages/trainingManagement/trainingDetail";
import addLatoja from "@/pages/trainingManagement/addLatoja";
import examInfo from "@/pages/trainingManagement/examInfo";
import lookExam from "@/pages/student/lookExam";
Vue.use(Router);

let router = new Router({
  mode: "history",
  //base: '/dist',
  routes: [{
      path: "/404",
      name: "notFound",
      component: NotFount
    },
    {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/404" //无匹配到的路径自动重定向到404页面
    },
    {
      path: "/login",
      name: "登录",
      component: Login
    },
    {
      path: "/qywxLogin",
      name: "登录",
      component: () => import("@/pages/qywxLogin/index.vue")
    },
    {
      path: "/webs-index",
      name: "首页 ",
      component: () => import("@/pages/home/index.vue")
    },
    {
      path: '/jg-login',
      name: '监管端登录',
      component: JgLogin
    },
    {
      path: '/helps',
      name: '帮助中心 ',
      component: () => import('@/components/help/index.vue'),
    },
    {
      path: '/customer',
      name: '提示',
      component: Customer
    },
    {
      path: '/invite',
      name: '启动',
      component: invite
    },
    {
      path: '/register',
      name: '注册',
      component: Register
    },
    {
      path: '/cadet/register',
      name: '注册',
      component: () => import('@/components/cadet/register/index.vue'),
    },

    {
      path: '/success',
      name: '注册成功',
      component: Success
    },
    {
      path: '/cadet/agency',
      name: '注册机构',
      component: () => import('@/components/cadet/register/agency.vue'),
    },

    {
      path: '/recommend',
      name: '推荐',
      component: Recommend
    },
    {
      path: "/",
      component: Home,
      name: "优加特科技",
      menuShow: true,
      iconCls: "iconfont icon-setting1",
      children: [{
          path: "running",
          component: () => import("@/pages/v2/related/index.vue"),
          name: "running",
          meta: {
            title: "财务管理"
          },
          redirect: "/running/index",
          children: [{
            path: "/running/index",
            component: resolve =>
              require(["@/pages/running/index.vue"], resolve),
            name: "平台流水",
            menuShow: true,
            meta: {
              activeMenu: "/running"
            }
          }]
        },
        {
          path: "related",
          component: () => import("@/pages/v2/related/index.vue"),
          name: "xueyuanguanli",
          meta: {
            title: "反馈及投诉"
          },
          redirect: "/related/complaint",
          children: [{
              //   path: '/related/req',
              //   component: resolve => require(['@/pages/studentsRelated/faqConf.vue'], resolve),
              //   name: '常见问题设置',
              //   menuShow: true
              // },{
              path: "/related/complaint",
              component: resolve =>
                require([
                  "@/pages/studentsRelated/complaintRecord.vue"
                ], resolve),
              name: "学员反馈及投诉",
              menuShow: true,
              meta: {
                activeMenu: "/related"
              }
            },
            {
              path: "/related/quiz/comm",
              component: resolve =>
                require(["@/pages/studentsRelated/quizComm.vue"], resolve),
              name: "随堂交流管理",
              menuShow: true,
              meta: {
                activeMenu: "/related"
              }
            }
          ]
        },
        {
          path: "warning",
          component: () => import("@/pages/v2/warning/index.vue"),
          name: "xueyuanguanli",
          meta: {
            title: "预警管理"
          },
          redirect: "/warning/conf",
          children: [{
              path: "/warning/conf",
              component: resolve =>
                require(["@/pages/preWarning/preWarningConf.vue"], resolve),
              name: "预警设置",
              menuShow: true,
              meta: {
                activeMenu: "/warning"
              }
            },
            {
              path: "/warning/record",
              component: resolve =>
                require(["@/pages/preWarning/preWarningRecord.vue"], resolve),
              name: "预警短信发送记录",
              menuShow: true,
              meta: {
                activeMenu: "/warning"
              }
            },
            {
              path: "/warning/monitor",
              component: resolve =>
                require(["@/pages/preWarning/preWarningMonitor.vue"], resolve),
              name: "预警监控",
              menuShow: true,
              meta: {
                activeMenu: "/warning"
              }
            }
          ]
        },
        {
          path: "system",
          component: () => import("@/pages/v2/system/index.vue"),
          name: "system",
          meta: {
            title: "操作日志"
          },
          redirect: "/system/login/log",
          children: [{
              path: "/system/login/log",
              // component: resolve =>
              //   require(["@/pages/yjt/log/systemLog/loginLog.vue"], resolve),
              component: () => import("@/pages/yjt/log/systemLog/loginLog.vue"),
              name: "登录日志",
              menuShow: true,
              meta: {
                activeMenu: "/system"
              }
            },
            {
              path: "/system/learning/log",
              component: resolve =>
                require([
                  "@/pages/yjt/log/learningjournal/learningLog.vue"
                ], resolve),
              name: "学习日志",
              menuShow: true,
              meta: {
                activeMenu: "/system"
              }
            },
            {
              path: "/system/load/log",
              component: resolve =>
                require(["@/pages/yjt/log/loadLog/loadLog.vue"], resolve),
              name: "预警日志",
              menuShow: true,
              meta: {
                activeMenu: "/system"
              }
            },
            {
              path: "/system/operation/log",
              component: resolve =>
                require(["@/pages/yjt/log/operationLog/log.vue"], resolve),
              name: "操作日志",
              menuShow: true,
              meta: {
                activeMenu: "/system"
              }
            }
          ]
        },
        {
          path: "statistical",
          component: () => import("@/pages/v2/statistical/index.vue"),
          name: "xueyuanguanli",
          meta: {
            title: "统计查询"
          },
          redirect: "/statistical/training/record",
          children: [{
              path: "/statistical/training/record",
              component: resolve =>
                require(["@/pages/statistics/trainingRecord.vue"], resolve),
              name: "培训记录",
              menuShow: true,
              meta: {
                activeMenu: "/statistical"
              }
            },
            {
              path: "/statistical/user/index",
              component: resolve =>
                require(["@/pages/statistics/userIndex.vue"], resolve),
              name: "信息查询",
              menuShow: true,
              meta: {
                activeMenu: "/statistical"
              }
            },
            {
              path: "/statistical/study/index",
              component: resolve =>
                require(["@/pages/statistics/learningSituation.vue"], resolve),
              name: "学习情况",
              menuShow: true,
              meta: {
                activeMenu: "/statistical"
              }
            }
          ]
        },
        {
          path: "user",
          component: () => import("@/pages/v2/user/index.vue"),
          name: "xueyuanguanli",
          meta: {
            title: "学员管理"
          },
          redirect: "/admin/user",
          children: [{
              path: "/admin/user",
              component: resolve =>
                require(["@/components/user/list.vue"], resolve),
              name: "用户列表",
              menuShow: true,
              meta: {
                activeMenu: "/user"
              }
            },
            {
              path: "/admin/member",
              component: resolve =>
                require(["@/components/user/member.vue"], resolve),
              name: "成员管理",
              menuShow: true,
              meta: {
                activeMenu: "/user"
              }
            },
            {
              path: "/admin/org",
              component: resolve =>
                require(["@/components/user/org.vue"], resolve),
              name: "机构管理",
              menuShow: true,
              meta: {
                activeMenu: "/user"
              }
            },
            {
              path: "/archives/personage",
              // component: osofDir,
              component: () =>
                import(
                  "@/pages/trainingManagement/archives/personage/index.vue"
                ),
              name: "一人一档",
              menuShow: true,
              meta: {
                activeMenu: "/user"
              }
            },
            {
              path: "/archives/personage/one",
              // component: osofDir,
              component: () =>
                import("@/pages/trainingManagement/archives/personage/one.vue"),
              name: "一人一档",
              menuShow: true,
              meta: {
                activeMenu: "/user"
              }
            }
          ]
        },
        {
          path: "examination",
          component: () => import("@/pages/v2/examination/index.vue"),
          name: "kczygl",
          meta: {
            title: "课程资源管理"
          },
          redirect: "/questionBank",
          children: [{
              path: "/trainingManagement/pushList",
              component: resolve =>
                require([
                  "@/pages/trainingManagement/tpush/pushList.vue"
                ], resolve),
              name: "推送管理",
              menuShow: true,
              meta: {
                activeMenu: "/questionBank"
              }
            },
            {
              path: "/trainingManagement/pushList2",
              component: resolve =>
                require([
                  "@/pages/trainingManagement/tpush/pushList2.vue"
                ], resolve),
              name: "班级管理",
              menuShow: true,
              meta: {
                activeMenu: "/questionBank"
              }
            },
            {
              path: "/examination/course/courseManagement",
              component: courseManagement,
              name: "课程管理",
              menuShow: true,
              meta: {
                activeMenu: "/questionBank"
              }
            },
            {
              path: "/trainingManagement/trainingResource",
              component: trainingResource,
              name: "培训资源管理",
              menuShow: true,
              meta: {
                activeMenu: "/questionBank"
              }
            },
            {
              path: "/examination/paperManagement",
              component: () => import("@/pages/examination/paperManagement"),
              name: "试卷管理",
              menuShow: true,
              meta: {
                activeMenu: "/questionBank"
              }
            },
            {
              path: "/questionBank",
              component: () => import("@/pages/questionBank/index.vue"),
              name: "试题管理",
              menuShow: true,
              meta: {
                activeMenu: "/questionBank"
              }
            }
          ]
        },


        {
          path: "management",
          component: () => import("@/pages/v2/management/index.vue"),
          name: "xueyuanguanli",
          meta: {
            title: "系统管理"
          },
          // redirect: "/transCode/list",
          redirect: "admin/role",
          children: [{
              path: "/transCode/list",
              component: () => import("@/pages/security/transCode/list"),
              name: "码表字典",
              menuShow: true,
              meta: {
                activeMenu: "/management"
              }
            },
            {
              path: "/dictionary/list",
              component: () => import('@/pages/security/dictionary/list'),
              name: "字典表管理",
              menuShow: true,
              meta: {
                activeMenu: "/management"
              }
            },
            {
              path: "/admin/role",
              component: () => import('@/components/role/list'),
              name: "角色管理",
              menuShow: true,
              meta: {
                activeMenu: "/management"
              }
            },
            {
              path: "/admin/member",
              component: () => import('@/components/user/member.vue'),
              name: "成员管理",
              menuShow: true,
              meta: {
                activeMenu: "/management"
              }
            },
            {
              path: "/admin/menu",
              component: () => import('@/components/menu/list'),
              name: "菜单管理",
              menuShow: true,
              meta: {
                activeMenu: "/management"
              }
            },
            {
              path: "/admin/params",
              component: () => import('@/components/menu/params'),
              name: "系统配置",
              menuShow: true,
              meta: {
                activeMenu: "/management"
              }
            },
          ]
        },
      ]
    },

    // 逻辑处理
    {
      path: "/",
      component: Home,
      name: "课程资源管理",
      children: [{
          path: "/examination/course/addCourse",
          component: addCourse,
          name: "新增课程",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/mall/examination/course/addCourse",
          component: mallAddCourse,
          name: "新增课程",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/examination/course/updateCourse",
          component: addCourse,
          name: "编辑课程",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/mall/examination/course/updateCourse",
          component: mallAddCourse,
          name: "编辑课程",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/examination/course/detailCourse",
          component: addCourse,
          name: "课程信息",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/mall/examination/course/detailCourse",
          component: mallAddCourse,
          name: "课程信息",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/examination/directory",
          component: directory,
          name: "目录",
          menuShow: true
        },

        {
          path: "/mall/trainingManagement/trainingResource",
          component: mallTrainingResource,
          name: "培训资源管理",
          menuShow: true
        },

        {
          path: "/trainingManagement/latojaManagement",
          component: latojaManagement,
          name: "线下培训管理",
          menuShow: true
        },
        {
          path: "/trainingManagement/trainingResourceDetail",
          component: trainingResourceDetail,
          name: "课件详情",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/trainingManagement/trainingResourceAdd",
          component: trainingResourceDetail,
          name: "新增课件",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/mall/trainingManagement/trainingResourceAdd",
          component: mallTrainingResourceDetail,
          name: "新增课件",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/trainingManagement/trainingResourceUpdate",
          component: trainingResourceDetail,
          name: "编辑课件",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/mall/trainingManagement/trainingResourceUpdate",
          component: mallTrainingResourceDetail,
          name: "编辑课件",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/trainingManagement/teacherManagement",
          component: teacherManagement,
          name: "师资管理",
          menuShow: true
        },
        {
          path: "/trainingManagement/detailTeacher",
          component: addTeacher,
          name: "师资信息",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/trainingManagement/addTeacher",
          component: addTeacher,
          name: "新建师资",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/trainingManagement/updateTeacher",
          component: addTeacher,
          name: "编辑师资",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/examination/addPaper",
          component: addPaper,
          name: "试卷信息",
          menuShow: true,
          meta: {
            activeMenu: "/questionBank"
          }
        },
        {
          path: "/student/lookExam",
          component: lookExam,
          name: "查看试卷"
        },
        {
          path: "/recording",
          component: resolve =>
                require([
                  // "@/pages/student/individualCenter/questionBank/index.vue"
                  "@/pages/trainingManagement/tpush/pushList3.vue"
                ], resolve),
          name: "补录"
        },
        {
          path: "/learnCard",
          component: resolve =>
                require([
                  // "@/pages/student/individualCenter/questionBank/index.vue"
                  "@/pages/yjt/log/systemLog/learnCard.vue" 
                ], resolve),
          name: "学习卡"
        },
        {
          path: "/transCode/list",
          component: () => import("@/pages/security/transCode/list"),
          name: "码表字典管理",
          menuShow: true
        },
        {
          path: "tkzj",
          component: () => import("@/pages/questionBank/index3.vue"),
          name: "tkzj",
          meta: {
            title: "题库总计"
          },
          children: [{
              path: "/examination/questionBankManagenment",
              component: questionBankManagenment,
              name: "试题管理",
              menuShow: true
            },

            {
              path: "/mall/examination/paperManagement",
              component: mallPaperManagement,
              name: "试卷管理",
              menuShow: true
            },
            {
              path: "/examination/examManagement",
              component: examManagement,
              name: "考试管理",
              menuShow: true
            },
            {
              path: "/examination/examStatistics",
              component: examStatistics,
              name: "考试统计",
              menuShow: true
            },
            {
              path: "/examination/examStatisticsDetail",
              component: examStatisticsDetail,
              name: "考试统计详情",
              menuShow: true,
              meta: {
                activeMenu: "/examination/examStatistics"
              }
            },
            {
              path: "/mall/examination/addPaper",
              component: mallAddPaper,
              name: "试卷信息",
              menuShow: true,
              meta: {
                activeMenu: "/mall/examination/paperManagement"
              }
            },
            {
              path: "/examination/addQuestion",
              component: addQuestion,
              name: "新建题库",
              menuShow: true,
              meta: {
                activeMenu: "/examination/questionBankManagenment"
              }
            },
            {
              path: "/mall/examination/addQuestion",
              component: mallAddQuestion,
              name: "新建题库",
              menuShow: true,
              meta: {
                activeMenu: "/mall/examination/questionBankManagenment"
              }
            },
            {
              path: "/examination/detailQuestion",
              component: addQuestion,
              name: "题库详情",
              menuShow: true,
              meta: {
                activeMenu: "/examination/questionBankManagenment"
              }
            },
            {
              path: "/mall/examination/detailQuestion",
              component: mallAddQuestion,
              name: "题库详情",
              menuShow: true,
              meta: {
                activeMenu: "/mall/examination/questionBankManagenment"
              }
            },
            {
              path: "/examination/updateQuestion",
              component: addQuestion,
              name: "编辑题库",
              menuShow: true,
              meta: {
                activeMenu: "/examination/questionBankManagenment"
              }
            },
            {
              path: "/mall/examination/updateQuestion",
              component: mallAddQuestion,
              name: "编辑题库",
              menuShow: true,
              meta: {
                activeMenu: "/mall/examination/questionBankManagenment"
              }
            },
            {
              path: "/examination/issueExam",
              component: issueExam,
              name: "发布考试",
              menuShow: true,
              meta: {
                activeMenu: "/examination/examManagement"
              }
            },
            {
              path: "/mall/examination/directory",
              component: mallDirectory,
              name: "目录",
              menuShow: true
            }
          ]
        }
      ]
    },

    {
      path: "/",
      component: Home,
      name: "发现课程",
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: "fa fa-user", // 图标样式class
      children: [{
          path: "/course/mall",
          name: "商城",
          component: () => import("@/components/courseMall/index.vue")
        },
        {
          path: "/course/mall/detail",
          name: "商品详情",
          component: () => import("@/components/courseMall/detail.vue")
        }
      ]
    },
    {
      path: '/',
      component: Home,
      name: '设置',
      menuShow: true,
      iconCls: 'iconfont icon-setting1',
      children: [{
        path: '/user/profile',
        // component: UserProfile,
        component: () => import("@/components/user/profile"),
        name: '个人信息1',
        menuShow: true
      },
        {
          path: '/user/changepwd',
          component: () => import("@/components/user/changepwd"),
          // component: UserChangePwd,
          name: '修改密码',
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "学员",
      menuShow: true,
      leaf: true,
      children: [{
          path: "/student/myTrain",
          component: resolve =>
            require(["@/pages/student/myTrain.vue"], resolve),
          name: "我的培训",
          menuShow: true
        },
        {
          path: "/student/myExam",
          component: resolve =>
            require(["@/pages/student/myExam.vue"], resolve),
          name: "我的考试",
          menuShow: true
        },
        {
          path: "/student/learning/norm",
          component: resolve =>
            require(["@/pages/student/learningNorm/index.vue"], resolve),
          name: "学习规范",
          menuShow: true
        },
        {
          path: "/student/train",
          component: resolve =>
            require(["@/pages/student/train.vue"], resolve),
          name: "开始学习",
          leaf: true,
          menuShow: true
        },
        {
          path: '/sheet',
          name: '答题首页',
          component: () => import('@/pages/answerSheet/index.vue'),
        },
        {
          path: '/no-data',
          name: '暂无数据',
          component: () => import('@/pages/answerSheet/common/noData.vue'),
        },



        {
          path: '/answer',
          name: '答题',
          component: () => import('@/pages/answerSheet/common/answer/answer.vue'),
        },
        {
          path: "/individual/center/feedback",
          component: resolve =>
            require([
              "@/pages/student/individualCenter/feedback/index.vue"
            ], resolve),
          name: "反馈",
          menuShow: true
        },
        {
          path: "individual",
          component: () => import("@/pages/v2/center/index.vue"),
          name: "individual",
          meta: {
            title: "用户中心"
          },
          redirect: "/individual/center/learning-cert",
          children: [
            {
              path: "/individual/center/learning-record",
              component: resolve =>
                require([
                  "@/pages/student/individualCenter/learningRecord/index.vue"
                ], resolve),
              name: "学习记录",
              menuShow: true
            },
            {
              path: "/individual/center/course-answers",
              component: resolve =>
                require([
                  "@/pages/student/individualCenter/courseAnswers/index.vue"
                ], resolve),
              name: "课程问答",
              menuShow: true
            },
            {
              path: "/individual/center/exam-record",
              component: resolve =>
                require([
                  "@/pages/student/individualCenter/examRecord/index.vue"
                ], resolve),
              name: "考试记录",
              menuShow: true
            },
            {
              path: "/individual/center/learning-cert",
              component: resolve =>
                require([
                  "@/pages/student/individualCenter/learningCert/index.vue"
                ], resolve),
              name: "学时证明",
              menuShow: true
            },
            {
              path: "/individual/center/measurement-record",
              component: resolve =>
                require([
                  "@/pages/student/individualCenter/measurementRecord/index.vue"
                ], resolve),
              name: "在线测试记录",
              menuShow: true
            },
            {
              path: "/individual/center/question-bank",
              component: resolve =>
                require([
                  "@/pages/student/individualCenter/questionBank/index.vue"
                ], resolve),
              name: "题库",
              menuShow: true
            }
          ]
        }
      ]
    },
    {
      path: "/student/exam", // TODO 感觉暂时不需要实现
      component: resolve =>
        require(["@/pages/student/exam.vue"], resolve),
      name: "开始考试"
    },
  ]
});

import config from "@/config/config.js";

//begin
router.beforeEach((to, fromV, next) => {
  config.initConfig(window.location.hostname);
  console.log(to,fromV )
  // 判断是否是商城
  if (!config.includeMall && to.meta.group == "mall") {
    next({
      path: "/login"
    });
    return;
  }
  if (to.path.startsWith("/login")) {
    window.localStorage.removeItem("access-token");
    next();
  } else if (to.path.startsWith("/qywxLogin")) {
    next();
  } else if (to.path.startsWith("/index")) {
    next();
  } else if (to.path.startsWith("/indexs")) {
    next();
  } else if (to.path.startsWith("/h/mall/type")) {
    next();
  } else if (to.path.startsWith("/success")) {
    next();
  } else if (to.path.startsWith("/register")) {
    next();
  } else if (to.path.startsWith("/cadet/register")) {
    next();
  } else if (to.path.startsWith("/cadet/agency")) {
    next();
  } else if (to.path.startsWith("/demo")) {
    next();
  } else if (to.path.startsWith("/chart001")) {
    next();
  } else if (to.path.startsWith("/activate")) {
    next();
  } else if (to.path.startsWith("/videoList")) {
    next();
  } else if (to.path.startsWith("/invite")) {
    next();
  }
  //监管端
  else if (to.path.startsWith("/supervise")) {
    let user = window.localStorage.getItem("access-token");
    if (!user) {
      next({
        path: "/jg-login"
      });
    } else {
      next();
    }
  } else if (to.path.startsWith("/jg-login")) {
    next();
  }
  // else if (to.path.startsWith('/course/mall')) {
  //   next()
  // }
  else if (to.path.startsWith("/recommend")) {
    next();
  } else if (to.path.startsWith("/customer")) {
    next();
  } else if (to.path.startsWith("/detail")) {
    next();
  } else if (to.path.startsWith("/h/mall")) {
    next();
  } else if (to.path.startsWith("/enter")) {
    next();
  } else if (to.path.startsWith("/indexCes")) {
    next();
  } else if (to.path.startsWith("/web-index")) {
    next();
  } else if (to.path.startsWith("/webs-index")) {
    next();
  } else if (to.path.startsWith("/static/home/index.html")) {
    next();
  }
  else if (to.path.startsWith("/helps")) {
    next();
  } else if (to.path.startsWith("/about")) {
    next();
  } else if (to.path.includes("http")) {
    window.open(to.fullPath.substr(1));
  } else {
    let user = window.localStorage.getItem("access-token");
    if (!user) {
      location.replace('/login');
      // next({
      //   path: "/webs-index"
      // });
    } else {
      next();
      // TODO 这个代码有bug，会影响到其他平台ifname 内。没测试改好千万不要发布的线上
      // let userinfo = window.localStorage.getItem('userinfo');
      // if (userinfo.initializationState && userinfo.initializationState == 1) {
      //   next({path: '/user/changepwd?type=initialization'})
      // }
      // 判断是否为第三方平台嵌入， 如果是第三方嵌入，那么就进行用户数据的初始化操作
      if (window.localStorage.getItem("isEmbed") == "true") {
        let isEmbedInitData = window.localStorage.getItem("isEmbedInitData");
        if (isEmbedInitData != "true") {
          initEmbedData(next);
        } else {
          next();
        }
      } else {
        next();
      }
    }
  }
});

/**
 * 初始化嵌入模式的数据数据
 * @param next 路由（需要等用户信息初始化完成后再做跳转，否则存在页面获取不到 localStorage 中的数据）
 * @returns {Promise<void>}
 */
async function initEmbedData(next) {
  //标记嵌入初始化完成
  window.localStorage.setItem("isEmbedInitData", true);

  //初始化用户数据
  await api_user.currentUserInfo().then(result => {
    let userInfo = result.data;
    localStorage.setItem("userinfo", JSON.stringify(userInfo));
    localStorage.setItem("oldVersion", userInfo.version);
    localStorage.setItem("parent-company-id", userInfo.parentEnterpriseId);
    console.log("current user info ", userInfo);
    next();
  });

  // 获取专业类别
  DIC_API.getDictionaryTreeToMapAndList({
    code: $const.dictionary.TRAINING_INDUSTRY
  }).then(result => {
    localStorage.setItem("categoryList", JSON.stringify(result.data.datas));
    localStorage.setItem("industryMapObj", JSON.stringify(result.data.dataMap));
  });

  // 题型
  DIC_API.getListByParentCode({
    parentCode: "QUESTION"
  }).then(result => {
    localStorage.setItem("questionTypeList", JSON.stringify(result));
  });

  // 部门列表
  api_dept.getlistAll().then(res => {
    localStorage.setItem("departmentList", JSON.stringify(res.data));
  });

  // 负责人列表
  api_user.listNopagging().then(res => {
    localStorage.setItem("principalList", JSON.stringify(res));
  });

  // 获取部门树形结构
  api_dept.getTree().then(res => {
    localStorage.setItem("deptTree", JSON.stringify(res));
  });

  // 获取教学方式
  DIC_API.getListByParentCode({
    parentCode: "teaching_methods"
  }).then(result => {
    localStorage.setItem("teaching_methods", JSON.stringify(result));
  });

  // 获取教学方式
  DIC_API.getListByParentCode({
    parentCode: "assess_methods"
  }).then(result => {
    localStorage.setItem("assess_methods", JSON.stringify(result));
  });
  // 考试类型
  DIC_API.getListByParentCode({
    parentCode: "exam_type"
  }).then(result => {
    localStorage.setItem("exam_type", JSON.stringify(result));
  });
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js